import React, { useEffect } from "react";
import SettingsItemMobile from "./SettingsItemMobile";
import General from "../common/Sections/General";
import SettingsSectionHeader from "../common/SettingsSectionHeader";

const SettingsMobile = ({ sections, user, roles, routeSection, tabs, isRiskLocked }) => {
  useEffect(() => {
    // fixes scroll behavior on some iOS browsers
    window?.scrollTo(0,0);
  }, []);

  return (
    < div className="pb-24" >
      <General className="mb-2" user={user} isRiskLocked={isRiskLocked}/>
      {tabs.map((tab, idx) => {
        return (
          <div>
            <SettingsSectionHeader header={tab}/>
            {Object.values(sections[idx]).map(
              ({ title, summary, Component, accessor, canExpand = () => true }) => (
                <SettingsItemMobile
                  className
                  key={title}
                  title={title}
                  summary={summary}
                  Component={Component}
                  accessor={accessor}
                  user={user}
                  roles={roles}
                  isRiskLocked={isRiskLocked}
                  initiallyExpanded={
                    routeSection === title.toLowerCase().replace(/ /g, "-")
                  }
                  canExpand={canExpand({ isRiskLocked })}
                />
              ),
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SettingsMobile;
